import { INITIAL_STATE } from './state';
import { MeetingHistoryActions, } from './types';
export const reducer = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case MeetingHistoryActions.GET_MEETING_HISTORY:
            return getMeetingHistory(state, payload);
        case MeetingHistoryActions.SET_MEETING_HISTORY_IS_LOADING:
            return setMeetingHistoryIsLoading(state, payload);
        default:
            return state;
    }
};
function getMeetingHistory(state, payload) {
    return {
        ...state,
        data: { ...state.data, ...payload },
    };
}
function setMeetingHistoryIsLoading(state, isLoading) {
    return {
        ...state,
        isLoading,
    };
}
